import isEmpty from 'lodash/isEmpty';
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import './TaxonomyLookupModalFooter.custom.scss';

function TaxonomyLookupModalFooter({ clearSelected, opModel, applyChanges, transferEnabled }) {
  return (
    <div className="taxonomyLookupModal__footer">
      <div className="taxonomyLookupModal__footer_buttons">
        <Button
          buttonConfig={{
            type: 'link',
            size: 'sm',
            label: 'Clear selected',
            e2eName: 'taxonomyLookupModal-footer-clear',
          }}
          disabled={isEmpty(opModel.selection)}
          iconConfig={{
            name: 'delete',
            size: 'sm',
          }}
          onClick={clearSelected}
        />
        <Button
          disabled={isEmpty(opModel.selection) && !transferEnabled}
          buttonConfig={{
            type: 'primary',
            size: 'sm',
            label: 'Transfer',
            e2eName: 'taxonomyLookupModal-footer-transfer',
          }}
          iconConfig={{
            name: 'chevron-right',
            size: 'sm',
          }}
          onClick={applyChanges}
        />
      </div>
    </div>
  );
}

TaxonomyLookupModalFooter.propTypes = {
  opModel: PropTypes.object,
  transferEnabled: PropTypes.bool,
  clearSelected: PropTypes.func.isRequired,
  applyChanges: PropTypes.func.isRequired,
};

export default TaxonomyLookupModalFooter;
